import { connect } from 'react-redux'
import React, { PureComponent } from 'react'
import NotSupported from '../../views/notSupported/NotSupported'
import withTransition from '../../hoc/Transition'
import withResizer from '../../hoc/Resizer'

class NotSupportedConnector extends PureComponent {
	render() {
		return <NotSupported />
	}
}

export default withTransition(withResizer(connect(null, null)(NotSupportedConnector), 1024, 768))
